import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import DownloadButton from './DownloadButton';

export default {
  name: 'ImageDownloadMixin',
  components: { DownloadButton },
  data() {
    return {
      imageDownloading: false
    };
  },
  methods: {
    async downloadImages(images, fileName, prefixFunc) {
      this.imageDownloading = true;

      const zip = new JSZip();
      const fetchedImages = await this.fetchImages(images, prefixFunc);
      const img = zip.folder(fileName);

      fetchedImages.forEach((image) => {
        img.file(`${image.name}.jpg`, image, { base64: true });
      });

      zip.generateAsync({ type: 'blob' }).then((content) => {
        saveAs(content, fileName);
        this.imageDownloading = false;
      });
    },
    async fetchImages(images, prefixFunc) {
      const imagePromises = [];
      const fetchedImages = [];

      images.forEach((image) => {
        imagePromises.push(this.fetchImage(image, prefixFunc).then(res => fetchedImages.push(res)));
      });

      await Promise.all(imagePromises);

      return fetchedImages;
    },
    async fetchImage(image, prefixFunc) {
      const imageBlob = await fetch(image.file_urls.original).then(response => response.blob());
      const fileName = prefixFunc ? prefixFunc(image) : image.id;
      const imageFile = new File([imageBlob], fileName);

      return imageFile;
    }
  }
};
